import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		hasLogin: null,
		userInfo: null,
		headers: {},
		babyInfo:null,
		uploadMsg:0,
		claimMsg:0,
		allMsg:0,
		growupMsg:0,
		systemMsg:0,
		fonts:[],
		netWork: 2
	},
	mutations: {
		setNetwork(state,netWork) {
			state.netWork = netWork;
		},
		login(state) {
			state.hasLogin = true;
		},
		setHasLogin(state, hasLogin) {
			state.hasLogin = hasLogin
		},
		setUserInfo(state,userInfo) {
			state.userInfo = userInfo
		},
		setHeader(state,headers) {
			state.headers = headers
		},
		setBaby(state, babyInfo) {
			state.babyInfo = babyInfo
		},
		setUploadMsg(state,num) {
			state.uploadMsg = num
		},
		setAllMsg(state,num) {
			state.allMsg = num
		},
		setClaimMsg(state,num) {
			state.claimMsg = num
		},
		setGrowupMsg(state,num) {
			state.growupMsg = num
		},
		setSystemMsg(state,num) {
			state.systemMsg = num
		},
		setFonts(state,fonts) {
			state.fonts = fonts
		}
	},
	actions: {
		setNetwork({commit}, netWork) {
			commit('setNetwork', netWork)
		},
		setUserInfo({commit}, userInfo) {
			commit('setUserInfo', userInfo)
		},
		setBaby({commit}, babyInfo) {
			commit('setBaby', babyInfo)
		},
		setHeader({commit}, headers) {
			commit('setHeader', headers)
		},
		logOut({commit}) {
			commit('setHeader', {})
			commit('setUserInfo', null)
			commit('hasLogin', false)
			Cookies.remove('loginform')
		},
		setUploadMsg({commit},num) {
			commit('setUploadMsg', num)
		},
		setAllMsg({commit},num) {
			commit('setAllMsg', num)
		},
		setClaimMsg({commit},num) {
			commit('setClaimMsg', num)
		},
		setGrowupMsg({commit},num) {
			commit('setGrowupMsg', num)
		},
		setSystemMsg({commit},num) {
			commit('setSystemMsg', num)
		},
		setFonts({commit},fonts) {
			commit('setFonts', fonts)
		}
	}
})

export default store
